export const modalDarkColors = {
  background: '#000',
  modalCard: 'rgba(255, 255, 255, 0.1)',
  stroke: 'rgba(84, 84, 86, 0.60)',
  titleText: '#fff',
  textSecondary: 'rgba(235, 235, 245, 0.60)',
}
